import { Comment } from '../types';

/**
 * Сортирует комментарии по их естественному порядку в документе
 * (сначала по номеру ячейки, затем по номеру строки)
 */
export const sortCommentsByPosition = (comments: Comment[]): Comment[] => {
  return [...comments].sort((a, b) => {
    // Извлекаем номер ячейки из cellId (формат: "cell-X")
    const cellA = parseInt(a.cellId.split('-')[1]);
    const cellB = parseInt(b.cellId.split('-')[1]);
    
    // Сначала сортируем по номеру ячейки
    if (cellA !== cellB) {
      return cellA - cellB;
    }
    
    // Если ячейки одинаковые, сортируем по номеру строки
    return a.lineNumber - b.lineNumber;
  });
};

/**
 * Находит следующий комментарий в отсортированном списке
 */
export const getNextComment = (
  comments: Comment[], 
  activeComment: Comment | null
): Comment | null => {
  if (!activeComment || comments.length <= 1) return null;
  
  const sortedComments = sortCommentsByPosition(comments);
  const currentIndex = sortedComments.findIndex(c => c.id === activeComment.id);
  
  if (currentIndex === -1) return null;
  
  // Переходим к следующему комментарию или к первому, если текущий последний
  const nextIndex = (currentIndex + 1) % sortedComments.length;
  return sortedComments[nextIndex];
};

/**
 * Находит предыдущий комментарий в отсортированном списке
 */
export const getPrevComment = (
  comments: Comment[], 
  activeComment: Comment | null
): Comment | null => {
  if (!activeComment || comments.length <= 1) return null;
  
  const sortedComments = sortCommentsByPosition(comments);
  const currentIndex = sortedComments.findIndex(c => c.id === activeComment.id);
  
  if (currentIndex === -1) return null;
  
  // Переходим к предыдущему комментарию или к последнему, если текущий первый
  const prevIndex = (currentIndex - 1 + sortedComments.length) % sortedComments.length;
  return sortedComments[prevIndex];
};

/**
 * Возвращает первый комментарий в отсортированном списке
 */
export const getFirstComment = (comments: Comment[]): Comment | null => {
  if (comments.length === 0) return null;
  
  const sortedComments = sortCommentsByPosition(comments);
  return sortedComments[0];
}; 